import { useTranslation } from 'react-i18next';
import { Snackbar, AlertTitle } from '@mui/material';

import { RequestError } from 'api';
import RequestErrorModal from 'components/RequestErrorDialog/RequestErrorModal';
import { Alert, Dialog, TextV2 } from '@insights-ltd/design-library/components';

const PurchaseError = ({
  isError,
  error,
  reset,
  resetWallet,
}: {
  isError: boolean;
  error: unknown | null;
  reset: () => void;
  resetWallet: () => void;
}) => {
  const { t } = useTranslation();

  if (
    isError &&
    error instanceof RequestError &&
    error.status >= 400 &&
    error.status < 500
  ) {
    const unitBalanceError = error.errorCodes.find(
      (code) => code === 'INSUFFICIENT_UNITS',
    );

    const profileAlreadyExists = error.errorCodes.find(
      (code) => code === 'PROFILE_ALREADY_EXISTS',
    );

    if (profileAlreadyExists) {
      return (
        <Dialog
          title={t(
            'ui.event-management.learners.purchase-profiles.failed-purchase.title',
          )}
          open={isError}
          content={
            <TextV2 component="span">
              {t(
                'ui.event-management.learners.purchase-profiles.failed-purchase.description',
              )}
            </TextV2>
          }
          onClose={() => {
            resetWallet();
            reset();
          }}
          primaryButtonText={t(
            'ui.event-management.learners.purchase-profiles.failed-purchase.confirm',
          )}
        />
      );
    }

    if (unitBalanceError) {
      resetWallet();
      reset();

      return null;
    }

    return (
      <Snackbar open={isError} autoHideDuration={6000} onClose={reset}>
        <Alert elevation={6} variant="filled" onClose={reset} severity="error">
          <AlertTitle>
            {t('ui.event-management.events.purchase-profiles.purchase-error')}
          </AlertTitle>
        </Alert>
      </Snackbar>
    );
  }
  return (
    <RequestErrorModal
      open={isError}
      onClose={() => {
        resetWallet();
        reset();
      }}
    />
  );
};

export default PurchaseError;
